import axios from 'axios';
import type { GetPermissionsAppointmentDTO } from '@bb/domain/dist/types/dto/AppointmentController/getPermissionsAppointment';

const getPermissionsManyAppointments = async (apptIds: string[]) => {
  const { data } = await axios.get<
    Record<string, GetPermissionsAppointmentDTO>
  >(`/appointments/permissions_many`, {
    params: { appointmentIds: apptIds.join(',') },
  });
  return data;
};

export default getPermissionsManyAppointments;
